// extracted by mini-css-extract-plugin
export default {"sButton":"Button_sButton__qebtk","sButtonText":"Button_sButtonText__7u0nx","sButtonIcon":"Button_sButtonIcon__h+YN3"};